import type { icModel } from 'generated-ts-common';
import { intl } from '../../../lib';
import { isEmptyArray, isEmptyString } from '../../../util';

type EnhancedPatient = icModel.saf.infrastructure.model.patient.EnhancedPatient;

export type PatientDetailsPatientProp = {
  /**
   * The patient whose details are being displayed.
   */
  patient: Partial<EnhancedPatient>;
};

export const getPatientDetailsNotSpecifiedString = (): string =>
  '<' + intl('common.notspecified.cc') + '>';

// function to simply get "<Not Specified>" if the given value is not set or empty
export const getValueOrNotSpecifiedString = (value: unknown): unknown => {
  if (
    !value ||
    (typeof value === 'string' && isEmptyString(value)) ||
    (Array.isArray(value) && isEmptyArray(value))
  ) {
    return getPatientDetailsNotSpecifiedString();
  }
  return value;
};
